import { render, staticRenderFns } from "./UpsaleItem.vue?vue&type=template&id=5f617122&scoped=true&"
import script from "./UpsaleItem.vue?vue&type=script&lang=js&"
export * from "./UpsaleItem.vue?vue&type=script&lang=js&"
import style0 from "./UpsaleItem.vue?vue&type=style&index=0&id=5f617122&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f617122",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
